import React from 'react';
import { Calendar, Mail, Phone, MapPin, ArrowRight, ShieldCheck } from 'lucide-react';
export function BookingPage() {
  return <>
      {/* Hero */}
      <section className="bg-olive py-12 md:py-16" data-id="element-717">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-718">
          <div className="text-center max-w-3xl mx-auto" data-id="element-719">
            <span className="text-gold font-bold uppercase tracking-widest text-xs mb-4 block" data-id="element-720">
              BOOK ONLINE
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-721">
              Schedule Your{' '}
              <span className="italic text-cream" data-id="element-722">Appointment</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg font-medium" data-id="element-723">
              No waitlist — immediate availability. No referral required.
            </p>
          </div>
        </div>
      </section>

      {/* Two Options */}
      <section className="py-12 lg:py-16 bg-cream" data-id="element-724">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-725">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-726">
            {/* Option 1: Book Online */}
            <div className="bg-white rounded-2xl p-8 border-2 border-olive shadow-soft-lg flex flex-col" data-id="element-727">
              <div className="w-14 h-14 rounded-full bg-olive/10 flex items-center justify-center text-olive mb-5" data-id="element-728">
                <Calendar size={28} data-id="element-729" />
              </div>
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-3" data-id="element-730">
                Book Online
              </h2>
              <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow leading-relaxed" data-id="element-731">
                Book your appointment directly through our online scheduling
                system. Choose your preferred date, time, and session type —
                it's quick and easy.
              </p>
              <ul className="space-y-2 mb-8" data-id="element-732">
                <li className="flex items-center gap-2 text-sm text-charcoal/80 font-medium" data-id="element-733">
                  <span className="w-1.5 h-1.5 rounded-full bg-olive" data-id="element-734" />
                  Instant confirmation
                </li>
                <li className="flex items-center gap-2 text-sm text-charcoal/80 font-medium" data-id="element-735">
                  <span className="w-1.5 h-1.5 rounded-full bg-olive" data-id="element-736" />
                  See real-time availability
                </li>
                <li className="flex items-center gap-2 text-sm text-charcoal/80 font-medium" data-id="element-737">
                  <span className="w-1.5 h-1.5 rounded-full bg-olive" data-id="element-738" />
                  In-person or virtual options
                </li>
              </ul>
              <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-8 py-3.5 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto shadow-soft" data-id="element-739">
                Book Appointment Now
                <ArrowRight size={16} className="ml-2" data-id="element-740" />
              </a>
            </div>

            {/* Option 2: Contact Form */}
            <div className="bg-white rounded-2xl p-8 border border-charcoal/10 flex flex-col" data-id="element-741">
              <div className="w-14 h-14 rounded-full bg-olive/10 flex items-center justify-center text-olive mb-5" data-id="element-742">
                <Mail size={28} data-id="element-743" />
              </div>
              <h2 className="font-heading text-2xl font-bold text-charcoal mb-3" data-id="element-744">
                Send a Message
              </h2>
              <p className="text-charcoal/70 text-base font-medium mb-6 leading-relaxed" data-id="element-745">
                Have questions or prefer to reach out first? Fill out the form
                below and we'll get back to you within 24 hours.
              </p>

              <form className="space-y-4 flex-grow flex flex-col" onSubmit={e => e.preventDefault()} data-id="element-746">
                <div data-id="element-747">
                  <label htmlFor="booking-name" className="block text-sm font-bold text-charcoal mb-1.5 uppercase tracking-wide" data-id="element-748">
                    Full Name
                  </label>
                  <input type="text" id="booking-name" placeholder="Your full name" className="w-full px-4 py-3 rounded-lg border border-charcoal/15 bg-charcoal/5 focus:border-olive focus:ring-2 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base" data-id="element-749" />
                </div>
                <div data-id="element-750">
                  <label htmlFor="booking-email" className="block text-sm font-bold text-charcoal mb-1.5 uppercase tracking-wide" data-id="element-751">
                    Email Address
                  </label>
                  <input type="email" id="booking-email" placeholder="your@email.com" className="w-full px-4 py-3 rounded-lg border border-charcoal/15 bg-charcoal/5 focus:border-olive focus:ring-2 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base" data-id="element-752" />
                </div>
                <div data-id="element-753">
                  <label htmlFor="booking-phone" className="block text-sm font-bold text-charcoal mb-1.5 uppercase tracking-wide" data-id="element-754">
                    Phone Number
                  </label>
                  <input type="tel" id="booking-phone" placeholder="(555) 000-0000" className="w-full px-4 py-3 rounded-lg border border-charcoal/15 bg-charcoal/5 focus:border-olive focus:ring-2 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base" data-id="element-755" />
                </div>
                <div className="flex-grow" data-id="element-756">
                  <label htmlFor="booking-message" className="block text-sm font-bold text-charcoal mb-1.5 uppercase tracking-wide" data-id="element-757">
                    Message
                  </label>
                  <textarea id="booking-message" rows={4} placeholder="Tell us how we can help..." className="w-full px-4 py-3 rounded-lg border border-charcoal/15 bg-charcoal/5 focus:border-olive focus:ring-2 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base resize-none" data-id="element-758" />
                </div>
                <button type="submit" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-8 py-3.5 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-759">
                  Send Message
                </button>
              </form>

              <div className="flex items-center gap-2 text-xs text-charcoal/50 font-medium mt-4" data-id="element-760">
                <ShieldCheck size={14} data-id="element-761" />
                Your information is secure and confidential.
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 text-charcoal/70 font-medium text-sm" data-id="element-762">
            <a href="tel:5489000692" className="flex items-center gap-2 hover:text-olive transition-colors" data-id="element-763">
              <Phone size={16} data-id="element-764" />
              548-900-0692
            </a>
            <a href="mailto:esther@esthermensahcounselling.com" className="flex items-center gap-2 hover:text-olive transition-colors" data-id="element-765">
              <Mail size={16} data-id="element-766" />
              esther@esthermensahcounselling.com
            </a>
            <div className="flex items-center gap-2" data-id="element-767">
              <MapPin size={16} data-id="element-768" />
              370 Queens Ave, London, Ontario
            </div>
          </div>
        </div>
      </section>
    </>;
}